/**
 * Live Yotpo rating on product cards (settings.pcard_review_rating_source == 'api').
 * Reads Yotpo's v3 storefront API — the same backend the PDP widget uses, so the
 * card and the PDP always show the same numbers.
 */
(function () {
  var script = document.currentScript;
  var APP_KEY = script && script.getAttribute('data-app-key');
  if (!APP_KEY) return;

  var ENDPOINT = 'https://api-cdn.yotpo.com/v3/storefront/store/' + APP_KEY + '/product/';
  var cache = {};
  var timer = null;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        resolve(entry.target);
      });
    },
    { rootMargin: '300px 0px' }
  );

  function load(id) {
    if (!cache[id]) {
      cache[id] = fetch(ENDPOINT + encodeURIComponent(id) + '/ratings', { priority: 'low' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (data) {
          return (data && data.bottomline) || null;
        })
        .catch(function () {
          return null;
        });
    }
    return cache[id];
  }

  function resolve(el) {
    var id = el.getAttribute('data-product-id');
    if (!id) return;

    load(id).then(function (bottomline) {
      if (!bottomline) return;

      var score = bottomline.averageScore;
      var count = bottomline.totalReviews;
      var threshold = parseFloat(el.getAttribute('data-threshold')) || 0;
      if (!(score > 0) || !(count > 0) || score < threshold) return;

      var rounded = score.toFixed(1);
      el.querySelector('.product-card__rating-score').textContent = rounded;
      el.querySelector('.product-card__rating-count').textContent = '(' + count.toLocaleString('en-US') + ')';
      el.querySelector('.product-card__rating-stars').style.setProperty('--star-fill', score * 20 + '%');
      el.setAttribute('aria-label', rounded + ' out of 5 stars, ' + count + ' reviews');
      el.removeAttribute('aria-hidden');
      el.classList.add('is-resolved');
    });
  }

  function scan() {
    var pending = document.querySelectorAll('[data-yotpo-rating]:not([data-yotpo-seen])');
    Array.prototype.forEach.call(pending, function (el) {
      el.setAttribute('data-yotpo-seen', '');
      io.observe(el);
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(scan, 150);
  }

  // Catches every re-render path at once: facet filter, load more, search, quick view.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  scan();
})();
